import copy from "copy-to-clipboard";
import { useTranslation } from "react-i18next";

import ErrorMessageCopuIcon from "assets/icons/ErrorMessageCopuIcon.svg?react";
import WarningIcon24 from "assets/icons/WarningIcon24.svg?react";

import ResponseMessage from "./ResponseMessage";

import styles from "./ErrorMessage.module.scss";

interface ErrorMessageProps {
  errorMessage: string;
  actionsBar?: React.ReactNode;
}

const ErrorMessage = (props: ErrorMessageProps) => {
  const { errorMessage, actionsBar } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.errorMessage}>
      <div className={styles.header}>
        <div className={styles.headerText}>
          <WarningIcon24 className={styles.icon} />
          <span className={styles.title}>{t("results.messages.error")}</span>
        </div>
        <div className={styles.actionsBar}>{actionsBar}</div>
      </div>
      {!!errorMessage && (
        <div className={styles.descriptionContainer}>
          {" "}
          <ResponseMessage queryError={errorMessage} />
          <div
            className={styles.copyIcon}
            onClick={() => {
              if (typeof errorMessage === "string") {
                copy(errorMessage);
              }
            }}
          >
            <ErrorMessageCopuIcon />
          </div>
        </div>
      )}
    </div>
  );
};

export default ErrorMessage;
